module.exports = __webpack_public_path__ + "static/investor-8fddd244ca51c20cf5d6ea54d0f478b2.jpg";